"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./utils");
var event_info_sample_1 = require("./event-info-sample");
var subevent_sample_1 = require("./subevent-sample");
var event_1 = require("./event");
var EventSample = /** @class */ (function () {
    function EventSample() {
    }
    EventSample.generateSample = function () {
        var _a;
        var event = new event_1.Event();
        var parent = { _id: event._id, uniqueVoucher: (_a = event.extraInfo) === null || _a === void 0 ? void 0 : _a.uniqueVoucher };
        event.info = event_info_sample_1.EventInfoSample.generateSample();
        event.subEvents = new Array(subevent_sample_1.SubEventSample.generateSample({ parent: parent }), subevent_sample_1.SubEventSample.generateSample({ parent: parent }), subevent_sample_1.SubEventSample.generateSample({ parent: parent }));
        return event;
    };
    EventSample = tslib_1.__decorate([
        utils_1.StaticImplements()
    ], EventSample);
    return EventSample;
}());
exports.EventSample = EventSample;
//# sourceMappingURL=event-sample.js.map